import { createFileRoute } from "@tanstack/react-router";
import SupplyReturnTable from "@/components/supply-return/supply-return-table";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useTranslate } from "@/hooks/use-translate";
import { SupplyReturnModals } from "@/components/supply-return/supply-return-modals";
import { useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/(dasboard)/inventory/supply-returns/")({
  component: SupplyReturnListBlock,
});

function SupplyReturnListBlock() {
  const { t } = useTranslate();
  const navigate = useNavigate();

  return (
    <section>
      <SupplyReturnModals />

      <header className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-4 gap-4">
        <h2 className="text-2xl font-semibold">{t("Supply Returns")}</h2>
        <Button
          onClick={() => {
            navigate({ to: "/inventory/supply-returns/create" });
          }}
        >
          <Plus className="w-4 h-4" />
          {t("Add Return")}
        </Button>
      </header>
      <SupplyReturnTable />
    </section>
  );
}
